import { render, staticRenderFns } from "./formNotifications.vue?vue&type=template&id=31327376&"
import script from "./formNotifications.vue?vue&type=script&lang=js&"
export * from "./formNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports